import axios from 'axios'
const url = '/contabilidad/alicuotaiva'


export default {

    index() {
        return axios.get(url);
    },
   


}